import { render } from "./indexapp.vue?vue&type=template&id=47fc01d4"
import script from "./indexapp.vue?vue&type=script&lang=js"
export * from "./indexapp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__